
interface ParticipationProps {
  onSubmitClick: () => void;
}

export default function Participation({ onSubmitClick }: ParticipationProps) {
  return (
    <section id="participation" className="py-32 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-20">
          <div className="inline-block w-16 h-px bg-neutral-300 mb-8"></div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl mb-8 font-light tracking-tight text-neutral-900" style={{ fontFamily: 'Playfair Display, serif' }}>
            How to Participate
          </h2>
          <p className="text-lg text-neutral-600 font-light max-w-2xl mx-auto">
            이벤트 참여방법을 선택하세요
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="group bg-neutral-50 p-12 transition-all duration-500 hover:bg-neutral-900 cursor-pointer">
            <div className="text-center">
              <div className="mb-8 flex items-center justify-center w-20 h-20 bg-white mx-auto transition-colors duration-300 group-hover:bg-neutral-800">
                <i className="ri-calendar-check-line text-3xl text-neutral-900 transition-colors duration-300 group-hover:text-white"></i>
              </div>
              <h3 className="text-2xl mb-6 font-light tracking-tight transition-colors duration-300 group-hover:text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
                촬영 예약
              </h3>
              <p className="text-neutral-600 mb-10 leading-relaxed font-light transition-colors duration-300 group-hover:text-neutral-300">
                스튜디오 상이 처음이신가요? 이벤트 기간 동안 20만원 이상의 촬영을 예약하시는 고객님은 자동으로 경품 이벤트에 응모됩니다.
              </p>
              <a 
                href="https://map.naver.com/p/search/%EC%8A%A4%ED%8A%9C%EB%94%94%EC%98%A4%20%EC%83%81/place/1192560866"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full py-4 bg-neutral-900 text-white text-sm tracking-[0.2em] uppercase font-medium transition-all duration-300 group-hover:bg-white group-hover:text-neutral-900 cursor-pointer whitespace-nowrap"
              >
                Reserve Now
              </a>
            </div>
          </div>

          <div className="group bg-neutral-50 p-12 transition-all duration-500 hover:bg-neutral-900 cursor-pointer">
            <div className="text-center">
              <div className="mb-8 flex items-center justify-center w-20 h-20 bg-white mx-auto transition-colors duration-300 group-hover:bg-neutral-800">
                <i className="ri-file-text-line text-3xl text-neutral-900 transition-colors duration-300 group-hover:text-white"></i>
              </div>
              <h3 className="text-2xl mb-6 font-light tracking-tight transition-colors duration-300 group-hover:text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
                기존 고객
              </h3>
              <p className="text-neutral-600 mb-10 leading-relaxed font-light transition-colors duration-300 group-hover:text-neutral-300">
                기존에 스튜디오 상을 이용해주셨다면,<br />
                간단한 동의 절차로 손쉽게 이벤트에 참여하실 수 있습니다.
              </p>
              <button 
                onClick={onSubmitClick}
                className="w-full py-4 bg-neutral-900 text-white text-sm tracking-[0.2em] uppercase font-medium transition-all duration-300 group-hover:bg-white group-hover:text-neutral-900 cursor-pointer whitespace-nowrap"
              >
                Submit Entry
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
